import {TimeType} from '../../../types/TimeType';

const MIN_TIME_DEFAULT: TimeType = '00:00';
const MAX_TIME_DEFAULT: TimeType = '23:59';

export function isTimeDisabled(
  time: TimeType,
  minTime: TimeType = MIN_TIME_DEFAULT,
  maxTime: TimeType = MAX_TIME_DEFAULT
): boolean {
  return time < minTime || time > maxTime;
}
